import { Empty, Typography } from "antd";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { useItemSidebarContext } from "../../../lib/hooks/basic/basic";

interface EmptyStateProps {
  hasFilters?: boolean;
  customEmptyText?: ReactNode | (() => ReactNode);
}

export function EmptyState({ hasFilters, customEmptyText }: EmptyStateProps) {
  const { setCurrentAction } = useItemSidebarContext();

  if (!hasFilters && customEmptyText) {
    const content =
      typeof customEmptyText === "function"
        ? customEmptyText()
        : customEmptyText;
    return <>{content}</>;
  }

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_DEFAULT}
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexFlow: "column",
      }}
      description={
        hasFilters ? (
          <FormattedMessage
            id="noDataMatchingFilters"
            defaultMessage="No records match your selected filters"
          />
        ) : (
          <FormattedMessage id="noData" defaultMessage="No Data" />
        )
      }
    >
      {hasFilters && (
        <Typography.Link onClick={() => setCurrentAction("filters")}>
          <FormattedMessage id="editFilters" defaultMessage="Edit filters" />
        </Typography.Link>
      )}
    </Empty>
  );
}
